import React, { useId, useRef, useState } from 'react';
import { ChevronDown } from '../assets/AppIcons';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { entityLabel } from '../utils/entitySelection';
import './entity-multi-select.css';

export { entityLabel, selectedEntityIds, entitySelectionPayload } from '../utils/entitySelection';

export default function EntityMultiSelect({ id, label, options = [], value = [], onChange, disabled = false, required = false, getLabel = entityLabel }) {
  const generatedId = useId();
  const controlId = id || generatedId;
  const searchRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const selected = value.map(String);
  const available = [...options];
  selected.forEach((key) => {
    if (!available.some((option) => String(option.id) === key)) available.push({ id: key, name: `Selezionato: ${key}` });
  });
  const filtered = available.filter((option) => getLabel(option).toLocaleLowerCase('it').includes(query.toLocaleLowerCase('it')));
  const selectedLabels = selected.map((key) => getLabel(available.find((option) => String(option.id) === key)));
  function changeOpen(next) { setOpen(next); if (!next) setQuery(''); }

  return <div className="entity-multi-select">
    <Popover open={open && !disabled} onOpenChange={changeOpen}>
      <PopoverTrigger asChild>
        <button id={controlId} type="button" role="combobox" aria-label={label} aria-required={required}
          aria-expanded={open && !disabled} aria-haspopup="dialog" aria-controls={open ? `${controlId}-options` : undefined}
          className="entity-multi-select__trigger" disabled={disabled}
          onKeyDown={(event) => {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); changeOpen(true); }
          }}>
          <span className={selected.length ? '' : 'entity-multi-select__placeholder'}>
            {selectedLabels.join(', ') || `Seleziona ${label.toLocaleLowerCase('it')}`}
          </span>
          <ChevronDown size={16} aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent id={`${controlId}-options`} align="start" className="entity-multi-select__popover" aria-label={label}
        onOpenAutoFocus={(event) => { event.preventDefault(); searchRef.current?.focus(); }}>
        <input ref={searchRef} type="search" aria-label={`Cerca ${label.toLocaleLowerCase('it')}`} placeholder="Cerca..."
          value={query} onChange={(event) => setQuery(event.target.value)}
          onKeyDown={(event) => { if (event.key === 'Enter') event.preventDefault(); }} />
        <div className="entity-multi-select__options" role="group" aria-label={`Opzioni ${label.toLocaleLowerCase('it')}`}>
          {filtered.map((option) => {
            const key = String(option.id);
            return <label key={key} className={`entity-multi-select__option${selected.includes(key) ? ' is-selected' : ''}${option.disabled ? ' is-disabled' : ''}`}>
              <input id={option.inputId} type="checkbox" checked={selected.includes(key)} disabled={Boolean(option.disabled)}
                onChange={() => onChange(selected.includes(key) ? selected.filter((value) => value !== key) : [...selected, key])} />
              <span>{getLabel(option)}{option.description ? <small>{option.description}</small> : null}</span>
            </label>;
          })}
          {!filtered.length ? <p>Nessun risultato</p> : null}
        </div>
        <small role="status">{selected.length} selezionati</small>
      </PopoverContent>
    </Popover>
  </div>;
}
